// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oC5A9gy9OSVVeEpkWagt {
	align-items: center;
	display: flex;
}

.pd_DdmN2fp473lEr9RlQ {
	flex: 1;
	margin-right: 10px;
	opacity: 0.3;
	text-transform: uppercase;
}

.pd_DdmN2fp473lEr9RlQ a {
	color: inherit;
	text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CrossChainFarmPageV2/FarmDetails/FarmInfo.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,OAAO;CACP,kBAAkB;CAClB,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,0BAA0B;AAC3B","sourcesContent":[".container {\n\talign-items: center;\n\tdisplay: flex;\n}\n\n.title {\n\tflex: 1;\n\tmargin-right: 10px;\n\topacity: 0.3;\n\ttext-transform: uppercase;\n}\n\n.title a {\n\tcolor: inherit;\n\ttext-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `oC5A9gy9OSVVeEpkWagt`,
	"title": `pd_DdmN2fp473lEr9RlQ`
};
export default ___CSS_LOADER_EXPORT___;
